import type { ComponentPropsWithRef } from 'react';

import { cx } from '@/shared/lib/cx';

import styles from './Counter.module.scss';

export type CounterTone = 'neutral' | 'accent' | 'danger';

const TONE: Record<CounterTone, string> = {
  neutral: styles['counter--neutral'] ?? '',
  accent: styles['counter--accent'] ?? '',
  danger: styles['counter--danger'] ?? '',
};

export interface CounterProps extends Omit<ComponentPropsWithRef<'span'>, 'color' | 'children'> {
  value: number;
  /** Выше этого числа показывается «N+»: ширина пилюли не должна скакать. */
  max?: number;
  tone?: CounterTone;
  /**
   * Показывать ли ноль. По умолчанию нет: пустой счётчик рядом с пунктом
   * меню сообщает ровно ничего, но занимает место и отвлекает.
   */
  showZero?: boolean;
}

/**
 * Число в пилюле: счётчик сайтов у тенанта, черновиков в разделе,
 * непрочитанных уведомлений.
 */
export function Counter({
  value,
  max = 99,
  tone = 'neutral',
  showZero = false,
  className,
  ...rest
}: CounterProps) {
  if (value <= 0 && !showZero) {
    return null;
  }

  const label = value > max ? `${String(max)}+` : String(value);

  return (
    <span className={cx(styles['counter'], TONE[tone], className)} {...rest}>
      {label}
    </span>
  );
}
